import { render, staticRenderFns } from "./RegisterDeads.vue?vue&type=template&id=7bad8ddb"
import script from "./RegisterDeads.vue?vue&type=script&lang=js"
export * from "./RegisterDeads.vue?vue&type=script&lang=js"
import style0 from "./RegisterDeads.vue?vue&type=style&index=0&id=7bad8ddb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports